import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/our-work/web-design/WebDesignWork.tsx");
